<template>
  <div>
    <h4
      v-bind="attributesBinding"
      class="text-center pa-1"
      :class="currentField.isType == 'CIRCLE' ? ' rounded-circle' : null"
    >
      {{ currentField.value.ja ? currentField.value.ja : currentField.text }}
    </h4>
    <p
      class="ma-0 text-center text-caption"
      v-if="mainExpression == 'Preview' && isLanguage !== 'ja'"
    >
      {{ captionText }}
    </p>
  </div>
</template>


<script>
export default {
  name: "Title",
  store: ["mainExpression", "isLanguage"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      const { currentField } = this;
      var attr = {
        // style: { height: this.mainExpression == "Preview" ? "20px" : null },
      };
      if (currentField.id) {
        attr.id = `label-${currentField.id}`;
      }
      console.log("currentField: ", currentField.color);
      if (currentField.color) {
        attr.style = {
          ...attr.style,
          color: currentField.isType == "TEXT" ? currentField.color : "white",
        };
      }
      if (currentField.isType != "TEXT") {
        attr.style = {
          "background-color": currentField.color,
          ...attr.style,
        };
      }
      return attr;
    },
    captionText() {
      if (!this.currentField.value[this.isLanguage]) {
        return "";
      }
      return this.currentField.value[this.isLanguage];
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
p {
  line-height: 1;
}
h4 {
  user-select: none;
}
</style>
